import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const AmazonS3 = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="AmazonS3"
    height={height}
    width={width}
    title="Amazon S3 logo"
    titleId="amazon-s3-logo-title"
    viewBox="0 0 512 512"
    {...props}
  >
    <rect width="512" height="512" rx="15%" fill="#ffffff" />
    <path fill="#e05243" d="M260 348l-137 33V131l137 32z" />
    <path fill="#8c3123" d="M256 349l133 32V131l-133 32v186" />
    <g fill="#e05243">
      <path
        id="a"
        d="M256 64v97l58 14V93zm133 67v250l26-13V143zm-133 77v97l58-8v-82zm58 129l-58 14v97l58-29z"
      />
    </g>
    <use fill="#8c3123" transform="rotate(180 256 256)" xlinkHref="#a" />

    <path fill="#5e1f18" d="M314 175l-58 11-58-11 58-15 58 15" />

    <path fill="#f2b0a9" d="M314 337l-58-11-58 11 58 16 58-16" />
  </SvgIcon>
);
